import { render, staticRenderFns } from "./Dispatch.vue?vue&type=template&id=69e13eb7&scoped=true"
import script from "./Dispatch.vue?vue&type=script&lang=js"
export * from "./Dispatch.vue?vue&type=script&lang=js"
import style0 from "./Dispatch.vue?vue&type=style&index=0&id=69e13eb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e13eb7",
  null
  
)

export default component.exports